import React from "react";
import MuiLinearProgress from "@mui/material/LinearProgress";
import { LinearProgressProps } from "@mui/material";

import { useLinearProgressStyles } from "./LinearProgress.styles";

function LinearProgress(
  props: LinearProgressProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const linearProgressClasses = useLinearProgressStyles(props);

  return (
    <MuiLinearProgress {...props} ref={ref} classes={linearProgressClasses} />
  );
}

export default React.forwardRef(LinearProgress);
